import { AssistantMessageRecordDto } from '@mews-commander/data-access';
import { Loader } from '@mews-commander/ui';
import { DropdownItem } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { useAssistantMessageReplySummaryQuery } from '../../query/useAssistantMessageReplySummaryQuery';
import { MenuButton } from './MenuButton';
import { ErrorButton } from './ErrorButton';

interface SuggestionSummaryMenuProps {
    messageHistory: AssistantMessageRecordDto[];
    handleClick: (summary: string) => void;
}

export const SuggestionSummaryMenu = ({ messageHistory, handleClick }: SuggestionSummaryMenuProps) => {
    const {
        data: suggestionsSummary,
        isLoading,
        error,
        refetch,
    } = useAssistantMessageReplySummaryQuery(messageHistory);

    if (isLoading) {
        return <DropdownItem label={lt('CommunicationHubPreparingSuggestions')} leftDetail={<Loader size="small" />} />;
    }

    if (error) {
        return <ErrorButton handleClick={async () => refetch()} />;
    }

    return (
        <>
            {suggestionsSummary &&
                suggestionsSummary.map((summary) => (
                    <MenuButton
                        key={summary.summary}
                        label={summary.summary ? summary.summary : ''}
                        onClick={() => handleClick(summary.summary ? summary.summary : '')}
                    />
                ))}
        </>
    );
};
